import React, { useState, useEffect } from 'react';
import Header from '../../layouts/Header';
import { useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { Gift, Wallet } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import axiosInstance from '../../api/axios';
const OfferOfDay = () => {

    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [offerDayAccess, setOfferDayAccess] = useState([]);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("PettyCash:")
            );
            setOfferDayAccess(filteredAccess);
        }
    }, [access]);

    console.log("Offer Day Access :", offerDayAccess);

    const accessToken = localStorage.getItem('authToken');
    const [inputData, setInputData] = useState({
        title: '',
        applicableProducts: [],
        applicableCategories: [],
        applicableOutlets: [],
        startDateTime: null,
        endDateTime: null,
        excludedProducts: [],
        excludedCategories: [],
        excludedOutlets: [],
        dropAmount: '',
        dropPercent: '',
        image: null,
        quantityThreshold: '',
        userQuantityThreshold: '',
    });
    const [categoriesData, setCategoriesData] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [exProductList, setExProductList] = useState([]);
    const [outlets, setOutlets] = useState([]);

    const productsInfo = productsList.map((product) => ({
        value: product?._id,
        label: `${product?.name}`
    }));

    const getCategoryList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("masters/category/get", { headers });

            if (response?.data?.status === true) {
                setCategoriesData(response?.data?.data?.categories);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getProductsList = async (catId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("product", { headers });

            if (response?.data?.status === true) {

                setProductsList(response?.data?.data?.products);

                if (catId) {
                    let prod = response?.data?.data?.products;

                    let excludedProducts = response?.data?.data?.products?.filter((fi) =>
                        catId?.some((category) => category.value === fi?.category?._id)
                    );
                    setExProductList(catId ? excludedProducts : prod);

                } else {
                    let prod = response?.data?.data?.products;
                    console.log("produts :", prod);
                    setExProductList(prod);
                }

            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("outlet", { headers });

            if (response?.data?.status === true) {
                setOutlets(response?.data?.data?.outlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getOffersList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axiosInstance.get(``, { headers });
            console.log("Response of Offers List :", response);
            
        } catch (error) {
            
        }
    }

    useEffect(() => {
        getOffersList();
    }, [])
    
    
    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    <Row className="pt-3">
                        <Col>
                            <div className="d-flex align-items-center">
                                <Gift className="me-3 mb-1" size={26} color="#0d6efd" />
                                <h4 className="fw-semibold mb-1">OFFER FOR THE DAY</h4>
                            </div>
                        </Col>
                        <hr />
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}

export default OfferOfDay